var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}]},[_c('toggle-button',{attrs:{"switch-color":"#FFFFFF","width":40,"height":20,"color":_vm.colors,"sync":true,"value":_vm.value,"disabled":_vm.disabled},on:{"change":(evt) => _vm.$emit('input', evt.value)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }